import { useMemo } from 'react';

export default function useModalStyle(step) {
  return useMemo(() => {
    switch (step) {
      case 'VERIFYING_DNS':
        return {
          width: 360,
          height: 350,
        };
      case 'ERROR_FINAL':
      case 'ERROR':
        return {
          width: 800,
          height: 300,
        };
      default:
        return {
          width: 900,
          height: 630,
        };
    }
  }, [step]);
}
